import { storage, auth } from "../firebaseConfig.js";

export default class UploadAdapter {
    constructor( loader ) {
        // The file loader instance to use during the upload.
        this.loader = loader;
    }

    // Starts the upload process.
    upload() {
        this.storageRef = storage.ref()
        return this.loader.file
            .then( file => new Promise( ( resolve, reject ) => {
                this._initRequest( resolve, reject, file );
            } ) );
    }

    // Aborts the upload process.
    abort() {
        // debugger
        if ( this.uploadTask ) {
            this.uploadTask.cancel();
        }
    }

    _initRequest( resolve, reject, file ) {
        

        const fileRef = this.fileRef =  this.storageRef.child(`${auth.currentUser.uid}/customization/${file.name}`)
        const loader = this.loader;

        // debugger
        const uploadTask = this.uploadTask = fileRef.put(file)

        uploadTask.on('state_changed', 
         snapshot => {
            //  debugger
            console.log(snapshot)
            loader.uploadTotal = snapshot.totalBytes;
            loader.uploaded = snapshot.bytesTransferred;
         }, err => {
            //  debugger
            console.error(err)
            reject(err.message)
         }, async () => {
            //  debugger
            uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => resolve({default: downloadURL}))
        })

    }
}